module.exports = __webpack_public_path__ + "static/media/CA.f88dce18.png";